module.exports = "<div class=\"course-hot-div\">\n    <app-small-title [title]=\"coursetitle\" [borderLeft]=\"false\" [borderBottom]=\"true\"\n     [linkUrl]=\"true\" [link]=\" '/station' \"></app-small-title>\n    <course-hot-detail [couInfoData]=\"couInfoData\"></course-hot-detail>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/shared/course-hot/course-hot.component.html
// module id = ../../../../../src/app/shared/course-hot/course-hot.component.html
// module chunks = main